import { Injectable } from '@angular/core';
import { ViewportService } from './viewport.service';

export type DefaultLandingPage = 'landing' | 'kiln-list' | 'information-radiator';

@Injectable({
  providedIn: 'root',
})
export class DefaultLandingService {
  static readonly STORAGE_KEY = 'defaultLandingPage';
  static readonly OPTIONS: ReadonlyArray<{
    value: DefaultLandingPage;
    labelKey: string;
  }> = [
    { value: 'landing', labelKey: 'USER_SETTINGS.DEFAULT_LANDING_QUICK_ACTIONS' },
    { value: 'kiln-list', labelKey: 'USER_SETTINGS.DEFAULT_LANDING_KILN_LIST' },
    { value: 'information-radiator', labelKey: 'USER_SETTINGS.DEFAULT_LANDING_DASHBOARD' },
  ];

  constructor(private viewport: ViewportService) {}

  isValid(value: unknown): value is DefaultLandingPage {
    return value === 'landing' || value === 'kiln-list' || value === 'information-radiator';
  }

  /** Explicit user choice, or null if they have not set one. */
  getPreference(): DefaultLandingPage | null {
    try {
      const stored = localStorage.getItem(DefaultLandingService.STORAGE_KEY);
      if (this.isValid(stored)) {
        return stored;
      }
    } catch {
      // Ignore storage errors (private mode, etc.).
    }
    return null;
  }

  setPreference(page: DefaultLandingPage): void {
    if (!this.isValid(page)) {
      return;
    }
    try {
      localStorage.setItem(DefaultLandingService.STORAGE_KEY, page);
    } catch {
      // Ignore storage errors (private mode, etc.).
    }
  }

  /**
   * Route used after sign-in / Home: stored preference, otherwise kiln-list on
   * desktop and landing (Quick Actions) on phones.
   */
  getHomePath(): DefaultLandingPage {
    const stored = this.getPreference();
    if (stored) {
      return stored;
    }
    return this.viewport.shouldUseKilnListRoute() ? 'kiln-list' : 'landing';
  }
}
